"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ViewMore = void 0;
var react_1 = __importDefault(require("react"));
var ramda_1 = require("ramda");
var Container_1 = require("../Container/Container");
var ViewMore = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a, as = props.as, _b = props.autoload, autoload = _b === void 0 ? false : _b, renderChild = props.renderChild, TopLoader = props.TopLoader, BottomLoader = props.BottomLoader, className = props.className, rest = __rest(props, ["data", "as", "autoload", "renderChild", "TopLoader", "BottomLoader", "className"]);
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        TopLoader && react_1["default"].createElement(TopLoader, { className: "top-loader" }),
        !ramda_1.isEmpty(data) && (react_1["default"].createElement(Container_1.Container, __assign({ as: as, className: ['view-more', className] }, rest), data.map(renderChild))),
        BottomLoader && (react_1["default"].createElement(BottomLoader, { className: "bottom-loader", autoload: autoload && ramda_1.isEmpty(data) }))));
};
exports.ViewMore = ViewMore;
//# sourceMappingURL=ViewMore.js.map